export default __webpack_public_path__ + "static/media/info_iconGrey.87f53624.svg";